import React, { forwardRef, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { Tooltip, Typography } from 'antd'
import { isNil, size } from 'lodash'
import PropTypes from 'prop-types'

const TypographyLinkWrapper = forwardRef((props, ref) => {
  const history = useHistory()

  const navigate = useCallback(
    event => {
      event.preventDefault()
      if (!isNil(props.target)) {
        window.open(props.href, props.target)
      } else {
        history.push(props.href)
      }
    },
    [props, history],
  )

  return (
    <Tooltip title={size(props.children) > 30 ? props.children : undefined}>
      {!props.disabled ? (
        <Typography.Link
          strong={props.strong}
          ellipsis
          ref={ref}
          {...props}
          onClick={navigate}
        >
          {props.children}
        </Typography.Link>
      ) : (
        <Typography.Text strong={props.strong} ellipsis ref={ref}>
          {props.children}
        </Typography.Text>
      )}
    </Tooltip>
  )
})

TypographyLinkWrapper.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  strong: PropTypes.bool,
  target: PropTypes.string,
}

TypographyLinkWrapper.defaultProps = {
  disabled: false,
  strong: false,
  target: undefined,
}

export default TypographyLinkWrapper
